import {
	DocumentWorkflowInstanceSignatureStatus,
	DocumentWorkflowInstanceStatus,
} from '@dealstack/shared/lib/generated';

const SIGNED_STATUSES: readonly DocumentWorkflowInstanceSignatureStatus[] = [
	DocumentWorkflowInstanceSignatureStatus.SIGNED,
	DocumentWorkflowInstanceSignatureStatus.WAITING_FOR_WITNESS_SIGNATURES,
	DocumentWorkflowInstanceSignatureStatus.COMPLETED,
];

const FINISHED_WORKFLOW_STATUSES: readonly DocumentWorkflowInstanceStatus[] = [
	DocumentWorkflowInstanceStatus.COMPLETED,
	DocumentWorkflowInstanceStatus.CANCELLED,
];

/**
 * Mirrors the server's `assertClosableWithoutSignature`: not a finished workflow, and at least
 * one signed slot — no "an outstanding slot must exist" requirement. That gap matters for the
 * retry case: if `_closeSignatures` succeeds but `finaliseInstanceCompletion` fails, the instance
 * is left IN_PROGRESS with its slots already CLOSED_WITHOUT_SIGNATURE (neither signed nor
 * outstanding here) — the admin must still be able to see this action to retry the close. The
 * KYC refusal is deliberately not mirrored here — KYC forms are not shown on this page, and the
 * server still enforces it.
 */
export const canCloseDocument = ({
	workflowStatus,
	signerStatuses,
}: {
	workflowStatus: DocumentWorkflowInstanceStatus;
	signerStatuses: Array<DocumentWorkflowInstanceSignatureStatus | undefined>;
}): boolean => {
	if (FINISHED_WORKFLOW_STATUSES.includes(workflowStatus)) {
		return false;
	}
	return signerStatuses.some(
		(status) => status !== undefined && SIGNED_STATUSES.includes(status)
	);
};
